import cloneDeep from 'lodash.clonedeep';
import { select, put } from 'redux-saga/effects';

import {
  SetActiveElementsVisibilityAction,
  SetElementsVisibilityAction,
  updateScribe
} from 'js/actionCreators/scribeActions';
import { getHidableElements } from 'js/shared/helpers/scenesHelpers';
import { trackSetActiveElementsVisibility } from 'js/actionCreators/trackingActions';

import { getActiveElements, getScribeById } from '../selectors';

export function* setAllElementsVisibility({ scribeId, hidden }: SetElementsVisibilityAction) {
  const scribe = (yield select(getScribeById, scribeId)) as ReturnType<typeof getScribeById>;

  if (!scribe) return;

  const newScribe = cloneDeep(scribe);
  const hidableElements = getHidableElements(newScribe);
  if (hidableElements.length <= 0) return;

  hidableElements.forEach(el => {
    el.hidden = hidden;
  });

  yield put(updateScribe(newScribe));
}

export function* setActiveElementsVisibility({ scribeId, eventTrigger, hidden }: SetActiveElementsVisibilityAction) {
  const scribe = (yield select(getScribeById, scribeId)) as ReturnType<typeof getScribeById>;
  const activeElementIds = (yield select(getActiveElements)) as ReturnType<typeof getActiveElements>;
  if (!scribe || !activeElementIds) return;

  const elementsToUpdate = Array.isArray(activeElementIds) ? activeElementIds : [activeElementIds];

  const newScribe = cloneDeep(scribe);

  newScribe.elements.forEach(el => {
    if (elementsToUpdate.includes(el.id) && el.type !== 'Camera') {
      el.hidden = hidden;
    }
  });

  yield put(
    trackSetActiveElementsVisibility({
      scribeId,
      elementIds: elementsToUpdate,
      eventTrigger,
      eventName: hidden ? 'Hide Element' : 'Unhide Element'
    })
  );
  yield put(updateScribe(newScribe));
}
